import { NavigationRouteFunctionPPT, TemplateFieldsDisplayFn } from '../../models/template.model';
import {
  DF_MAP_CHINA_BEIJING,
  DF_MAP_CHINA_COMPARISON,
  DF_MAP_CHINA_SHANGHAI,
  DF_MAP_CHINA_SUMMARY,
  DF_MAP_EMEA_VAS,
  DF_MAP_INDIA_COMPARISON,
  DF_MAP_INDIA_OFFICE,
  DF_MAP_INDIA_OFFICE_GROUPED,
  DF_MAP_INDIA_RETAIL,
  DF_MAP_INDIA_RETAIL_GROUPED,
  DF_MAP_PACIFIC_AVAILABILITY_INDUSTRIAL,
  DF_MAP_PACIFIC_AVAILABILITY_OFFICE,
  DF_MAP_PACIFIC_AVAILABILITY_RETAIL,
  DF_MAP_PACIFIC_NZ_AVAILABILITY_INDUSTRIAL,
  DF_MAP_PACIFIC_SUMMARY_INDUSTRIAL,
  DF_MAP_PACIFIC_SUMMARY_OFFICE,
  DF_MAP_PACIFIC_SUMMARY_RETAIL,
  DF_MAP_UK_INDUSTRIAL,
  DF_MAP_UK_INT,
  DF_MAP_UK_LONG_INCOME,
  DF_MAP_UK_RESEARCH_AVAILABILITY,
  DF_MAP_UK_RESEARCH_DEVELOPMENT_PIPELINE,
  DF_MAP_US_AVAILABILITY,
  DF_MAP_US_AVAILABILITY_INDUSTRIAL,
  DF_MAP_US_AVAILABILITY_OFFICE,
  DF_MAP_US_AVAILABILITY_RETAIL,
  DF_MAP_US_LEASE,
  DF_MAP_US_PROPERTY_INDUSTRIAL,
  DF_MAP_US_PROPERTY_OFFICE,
  DF_MAP_US_PROPERTY_RETAIL,
  DF_MAP_US_PROPERTY_TABLE,
  DF_MAP_US_SALE,
  DF_MAP_US_TIM,
  DF_US_LEASE_CONDENSED,
  DF_US_LEASE_OFFICE,
  EMEA_AVAILABILITIES_NEXT_FIVE_COUNTRIES,
  EMEA_NEXT_FIVE_COUNTRIES,
  EMEA_NEXT_FIVE_INDUSTRIAL_COUNTRIES,
} from './config';
import {
  AVAILABILITY_ROUTE_FN,
  LEASE_ROUTE_FN,
  PROPERTY_ROUTE_FN,
  SALE_ROUTE_FN,
  TIM_ROUTE_FN,
} from './route-functions/common.route';

interface TemplateConfigurations {
  fieldsDisplayFunctions: TemplateFieldsDisplayFn;
  recordRouteFn?: NavigationRouteFunctionPPT | { [key: string]: NavigationRouteFunctionPPT };
}

export const TEMPLATE_CONFIGURATIONS: { [templateId: number]: TemplateConfigurations } = {
  2: { fieldsDisplayFunctions: DF_MAP_EMEA_VAS },
  3: { fieldsDisplayFunctions: DF_MAP_CHINA_BEIJING },
  4: { fieldsDisplayFunctions: DF_MAP_CHINA_SHANGHAI },
  5: { fieldsDisplayFunctions: DF_MAP_INDIA_COMPARISON },
  6: { fieldsDisplayFunctions: DF_MAP_INDIA_OFFICE },
  7: { fieldsDisplayFunctions: DF_MAP_INDIA_RETAIL },
  8: { fieldsDisplayFunctions: DF_MAP_US_PROPERTY_INDUSTRIAL, recordRouteFn: PROPERTY_ROUTE_FN },
  9: { fieldsDisplayFunctions: DF_MAP_US_PROPERTY_OFFICE, recordRouteFn: PROPERTY_ROUTE_FN },
  10: { fieldsDisplayFunctions: DF_MAP_US_PROPERTY_RETAIL, recordRouteFn: PROPERTY_ROUTE_FN },
  11: { fieldsDisplayFunctions: DF_MAP_UK_INDUSTRIAL },
  12: { fieldsDisplayFunctions: DF_MAP_US_TIM, recordRouteFn: TIM_ROUTE_FN },
  13: { fieldsDisplayFunctions: DF_MAP_US_AVAILABILITY_INDUSTRIAL, recordRouteFn: AVAILABILITY_ROUTE_FN },
  14: { fieldsDisplayFunctions: DF_MAP_US_AVAILABILITY_OFFICE, recordRouteFn: AVAILABILITY_ROUTE_FN },
  15: { fieldsDisplayFunctions: DF_MAP_US_AVAILABILITY_RETAIL, recordRouteFn: AVAILABILITY_ROUTE_FN },
  16: { fieldsDisplayFunctions: DF_MAP_PACIFIC_AVAILABILITY_OFFICE },
  17: { fieldsDisplayFunctions: DF_MAP_PACIFIC_AVAILABILITY_RETAIL },
  18: { fieldsDisplayFunctions: DF_MAP_PACIFIC_AVAILABILITY_INDUSTRIAL },
  19: { fieldsDisplayFunctions: DF_MAP_PACIFIC_SUMMARY_OFFICE },
  20: { fieldsDisplayFunctions: DF_MAP_PACIFIC_SUMMARY_RETAIL },
  21: { fieldsDisplayFunctions: DF_MAP_PACIFIC_SUMMARY_INDUSTRIAL },
  22: { fieldsDisplayFunctions: DF_MAP_PACIFIC_NZ_AVAILABILITY_INDUSTRIAL },
  23: { fieldsDisplayFunctions: DF_MAP_CHINA_SUMMARY },
  24: { fieldsDisplayFunctions: DF_MAP_UK_INT },
  25: { fieldsDisplayFunctions: DF_MAP_US_LEASE, recordRouteFn: LEASE_ROUTE_FN },
  26: { fieldsDisplayFunctions: DF_MAP_US_AVAILABILITY, recordRouteFn: AVAILABILITY_ROUTE_FN },
  27: { fieldsDisplayFunctions: DF_MAP_US_PROPERTY_TABLE, recordRouteFn: PROPERTY_ROUTE_FN },
  28: { fieldsDisplayFunctions: DF_MAP_US_SALE, recordRouteFn: SALE_ROUTE_FN },
  29: { fieldsDisplayFunctions: DF_MAP_CHINA_COMPARISON },
  34: { fieldsDisplayFunctions: EMEA_NEXT_FIVE_COUNTRIES },
  35: { fieldsDisplayFunctions: EMEA_NEXT_FIVE_COUNTRIES },
  36: { fieldsDisplayFunctions: EMEA_AVAILABILITIES_NEXT_FIVE_COUNTRIES },
  37: { fieldsDisplayFunctions: DF_MAP_UK_LONG_INCOME },
  38: { fieldsDisplayFunctions: DF_US_LEASE_CONDENSED },
  39: { fieldsDisplayFunctions: DF_US_LEASE_OFFICE },
  40: {
    fieldsDisplayFunctions: DF_MAP_UK_RESEARCH_AVAILABILITY,
    recordRouteFn: { property: PROPERTY_ROUTE_FN, availability: AVAILABILITY_ROUTE_FN },
  },
  41: { fieldsDisplayFunctions: EMEA_NEXT_FIVE_INDUSTRIAL_COUNTRIES },
  42: { fieldsDisplayFunctions: DF_MAP_UK_RESEARCH_DEVELOPMENT_PIPELINE, recordRouteFn: PROPERTY_ROUTE_FN },
  43: { fieldsDisplayFunctions: DF_MAP_INDIA_OFFICE_GROUPED },
  44: { fieldsDisplayFunctions: DF_MAP_INDIA_RETAIL_GROUPED },
};
